import { IAutorizacoes } from './../../../interfaces/token/IAutorizacoes';
import { AuthenticationService } from './../../../services/authentication/authentication.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { IFatura } from 'src/app/interfaces';
import { ListaPaginada } from 'src/app/models';
import { BoletoService, FaturaService, ToastService } from 'src/app/services';
import pdf from './pdf.json';
import { IToken } from 'src/app/interfaces/token/IToken';
import { NavigationExtras, Router } from '@angular/router';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';

@Component({
  selector: 'app-listar-demonstrativo-financeiro',
  templateUrl: './listar-demonstrativo-financeiro.component.html',
  styleUrls: ['./listar-demonstrativo-financeiro.component.scss']
})
export class ListarDemonstrativoFinanceiroComponent
  implements OnInit, OnDestroy
{
  subscriptions$ = new Subscription();
  filtraForm: FormGroup;
  faturas = new ListaPaginada<IFatura>();
  token: IToken = this.authenticationService.obterToken();
  faturaBase64: string;
  boletoBase64: string | null = null;
  nomeArquivoBoleto: IFatura;
  autorizacoes: IAutorizacoes;

  constructor(
    private fb: FormBuilder,
    private faturaService: FaturaService,
    private boletoService: BoletoService,
    private modalService: NgbModal,
    private toastService: ToastService,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];
  }

  getFatura(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.faturas.paginaAtual = 1;
    }

    const codClienteFiltro: string = this.filtraForm.get('codCliente')?.value;
    this.subscriptions$.add(
      this.faturaService
        .getFaturas({
          codCliente: codClienteFiltro ? [codClienteFiltro] : [],
          codContrato: this.token.codContrato,
          codGrupoEconomico: this.token?.codGrupoEconomico,
          FiltroPesquisar: this.filtraForm.get('FiltroPesquisar')?.value.trim(),
          tipoUsuario: this.token?.tipoUsuario,
          itensPorPagina: this.faturas.itensPorPagina,
          paginaAtual: this.faturas.paginaAtual
        })
        .subscribe({
          next: ({ data }) => {
            this.faturas = data;
          }
        })
    );
  }

  emitirCodigoContrato(fatura: IFatura) {
    const navigationExtras: NavigationExtras = {
      state: {
        value: fatura.codContrato,
        mesAnoFatura: fatura.mesAnoFatura
      }
    };
    this.router.navigateByUrl(
      `/demonstrativo-financeiro/${fatura.codContrato}`,
      navigationExtras
    );
  }

  ngOnInit() {
    this.filtraForm = this.fb.group({
      codCliente: [''],
      FiltroPesquisar: [''],
      vencFim: [''],
      vencInic: ['']
    });
    this.getFatura();
    this.gerenciarPermissoesTela();
  }

  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
  }

  visualizarFatura(modalVisualizarFatura, movimento: string) {
    if (movimento != '') {
      this.getFaturaPDF(movimento);
      this.modalService.open(modalVisualizarFatura, {
        centered: true,
        size: 'lg'
      });
    } else {
      this.toastService.error('Retorno do PDF de Fatura vazio.');
    }
  }

  visualizarBoleto(modalVisualizarBoleto, fatura: IFatura) {
    this.postViewBoleto(fatura, () => {
      this.modalService.open(modalVisualizarBoleto, {
        centered: true,
        size: 'lg'
      });
      return;
    });
  }

  getFaturaPDF(movimento: string) {
    this.faturaBase64 = pdf.pdf;
  }
  //TODO: criar postViewFatura()
  postViewBoleto(fatura: IFatura, executarAoCompletar: () => void) {
    this.subscriptions$.add(
      this.boletoService
        .postBoletoDownload({
          movimento: fatura.codFatura,
          cliente: fatura.codCliente!,
          empresa:
            fatura.codEmpresaFaturamentoContrato! || fatura.codEmpresaContrato!,
          tipo: fatura.codTipoDocumentoFatura!
        })
        .subscribe({
          next: ({ data }) => {
            this.boletoBase64 = data;
            this.nomeArquivoBoleto = fatura;
            executarAoCompletar();
          }
        })
    );
  }

  closeModal() {
    this.modalService.dismissAll();
    this.boletoBase64 = null;
  }
}
